module.exports = __webpack_public_path__ + "static/media/img146.e366311b.jpg";